import * as React from 'react';
import s from './noResultPage.scss';
import {withTranslation} from 'react-i18next';
import {Experiment} from '../../reducers/experiments';
import {connect} from 'react-redux';
import {State} from '../../reducers';
import {experimentsSelector} from '../../selectors/experiments';
import {History} from 'history';

export interface NoResultsPageProps {
  t?: (...args: any[]) => any;
  history: History;
  experiments?: Experiment[];
}

class NoResultsPageCmp extends React.Component<NoResultsPageProps, {}> {
  render() {
    const {t} = this.props;

    return (
      <div className={s.layout}>
        <h2 data-hooks="no-results-page-title" className={s.title}>
          {t('search.no.results.title')}
        </h2>
        <span className={s.description} data-hooks="no-results-page-description">{t('search.no.results.description')}</span>

      </div>
    );
  }
}

function mapStateToProps(state: State) {
  return {
    experiments: experimentsSelector(state),
  };
}

export default withTranslation()(connect(mapStateToProps)(NoResultsPageCmp)) as React.ComponentType<any>;
